import { API } from '../../common/api'
import { identityServiceUrl } from '../../common/utils/constants'

export type PartnerIqInvitationPayload = {
  partnerId: string
  userEmails: string[]
}

/**
 * Sends PartnerIQ invitation emails (7-day acceptance window).
 * TODO(backend): Implement POST on identity / marketplace service when endpoint is available.
 */
export const sendPartnerIqInvitations = async (
  payload: PartnerIqInvitationPayload
): Promise<void> => {
  try {
    await API.post(
      `${identityServiceUrl}/partners/${payload.partnerId}/partneriq/invitations`,
      {
        user_emails: payload.userEmails,
        expiry_days: 7,
      }
    )
  } catch (error) {
    // Endpoint may not exist yet — log and rethrow for caller to surface UI message
    console.warn(
      '[PartnerIQ] Invitation API not available — backend endpoint required:',
      `${identityServiceUrl}/partners/:partnerId/partneriq/invitations`,
      error
    )
    throw error
  }
}

/**
 * Persists org-level PartnerIQ enabled/disabled state.
 * TODO(backend): Confirm PATCH field `partnerIqEnabled` on partner subscription payload.
 */
export const updatePartnerIqOrgAccess = async (
  partnerId: string,
  enabled: boolean
): Promise<void> => {
  try {
    await API.patch(
      `${identityServiceUrl}/partners/${partnerId}/partneriq/access`,
      {
        enabled,
      }
    )
  } catch (error) {
    console.warn(
      '[PartnerIQ] Org access API not available — backend endpoint required:',
      `${identityServiceUrl}/partners/:partnerId/partneriq/access`,
      error
    )
    throw error
  }
}
